import styled from 'styled-components';


export const SpinnerBrandDefaultBox = styled.div`
    width: 180px;
    height: 180px;
    position: relative;
    
`;